import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=1f563d80&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=ts"
export * from "./Step3.vue?vue&type=script&lang=ts"
import style0 from "./Step3.vue?vue&type=style&index=0&id=1f563d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f563d80",
  null
  
)

export default component.exports